<template>
    <div>
        <footer class="main-footer div-home">
            <div class="back-to-top">
                <a href="#">

                    <div>
                        بازگشت به
                        بالا
                    </div>
                    <span class="icon"><i class="now-ui-icons arrows-1_minimal-up"></i></span>
                </a>
            </div>
            <div class="container">
                <!--<footer-services></footer-services>-->
                <!--<footer-widgets></footer-widgets>-->
                <footer-info></footer-info>
            </div>
            <footer-description></footer-description>
            <footer-copyright></footer-copyright>
            <!--<div class="js-wheel-floating-box">
                <div class="c-fmcg-voucher-box__free-shipping-holder js-wheel-floating-box-close"></div>
                <div class="c-fmcg-voucher-box--free-shipping js-wheel-floating-box-click">
                    <a class="link-watsap" href="https://api.whatsapp.com/send?phone=+989124465501" target="_blank">
                        <img src="/../../assets/img/whatsapp.png" />
                    </a>
                    <button class="js-wheel-floating-box-close">
                        <i class="bx bx-arrow-back"></i>
                    </button>
                </div>
            </div>-->
        </footer>
   </div>
</template>

<script>
    import footerCopyright from './footerCopyright.vue'
    import footerDescription from './footerDescription.vue'
    import footerInfo from './footerInfo.vue'
 
    export default {
        data() {
            return {
                isUserLogined: false
            }
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        components: {
            'footer-copyright': footerCopyright,
            'footer-description': footerDescription,
            'footer-info': footerInfo,
             
        }
    }
</script>

<style scoped>

    .js-wheel-floating-box {
        display: block;
    }

    .c-fmcg-voucher-box--free-shipping {
        top: 50%;
        left: 50%;
        width: 320px;
        height: 370px;
        z-index: 11000;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
    }

    .c-fmcg-voucher-box--free-shipping, .c-fmcg-voucher-box__free-shipping-holder {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: fixed;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

        .c-fmcg-voucher-box--free-shipping img {
            width: 100%;
            height: 320px;
        }

        .c-fmcg-voucher-box--free-shipping button, .c-fmcg-voucher-box--free-shipping button:before {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
        }

        .c-fmcg-voucher-box--free-shipping button {
            width: 36px;
            height: 36px;
            border: none;
            cursor: pointer;
            border-radius: 100%;
            background-color: rgba(0,0,0,.3);
        }

            .c-fmcg-voucher-box--free-shipping button i {
                font-size: 28px;
                color: #9999;
            }
 

    .c-fmcg-voucher-box--free-shipping button, .c-fmcg-voucher-box--free-shipping button:before {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .c-fmcg-voucher-box--free-shipping, .c-fmcg-voucher-box__free-shipping-holder {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: fixed;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .c-fmcg-voucher-box__free-shipping-holder {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100vh;
        z-index: 10000;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background-color: rgba(0,0,0,.6);
    }


     
</style>